module.exports = __webpack_public_path__ + "static/img/86-1.a08a7a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/86-1.jpg
// module id = 225O
// module chunks = 0